import type { EventName } from "@lit/react";
import { ListBox as ListBoxElement, type ListBoxEventMap as _ListBoxEventMap, } from "@vaadin/list-box/vaadin-list-box.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { ListBoxElement, };
export type ListBoxEventMap = Readonly<{
    onSelectedChanged: EventName<_ListBoxEventMap["selected-changed"]>;
    onSelectedValuesChanged: EventName<_ListBoxEventMap["selected-values-changed"]>;
    onItemsChanged: EventName<_ListBoxEventMap["items-changed"]>;
}>;
const events = { onSelectedChanged: "selected-changed", onSelectedValuesChanged: "selected-values-changed", onItemsChanged: "items-changed" } as ListBoxEventMap;
export type ListBoxProps = WebComponentProps<ListBoxElement, ListBoxEventMap>;
export const ListBox = createComponent({
    elementClass: ListBoxElement, events, react: React, tagName: "vaadin-list-box"
});
